/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */

/**
 * The Payable Item kinds PASS pays out through PPS.
 */
export type PaymentType = (typeof PaymentType)[keyof typeof PaymentType];

export const PaymentType = {
  stipend: "stipend",
  micropayment: "micropayment",
  receipt_claim: "receipt_claim",
  mileage_claim: "mileage_claim",
} as const;
